export function createFindInDiffWorker() {
  return new Worker(new URL('./find-in-diff.worker.ts', import.meta.url), {type: 'module'})
}
